import type { FaireProductEntity } from "../../entity_types/product";

export const p_3pcekmbkc4: FaireProductEntity = {
  token: "p_3pcekmbkc4",
  type: "product",
  name: "Evil Eye Adjustable Ring Hand-Drip Enamel Steel  S5P063",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/bb3f831a4d68bbd99cb39f06b6bf0f9ec21fe449639a0b563970e7ffd14b482d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/829b0fb456edcf9bbbaadd6eb67b915635e640a3baa15c6214ad677b30b4b1b8.jpeg",
    "https://cdn.faire.com/fastly/29e7a7c287993289fc786b8479df3772603c3ab7969ab94a006956c3e123c8f2.jpeg",
    "https://cdn.faire.com/fastly/bc84a4440ae34d6c77f1b0db5e28f9cf77702df418ea6148fbaab67c02baa5de.jpeg",
    "https://cdn.faire.com/fastly/b8d4018d32fed46c4f6925b5104efd6caf323b6dfa7bd61bb80f3cb469cfe1a3.jpeg",
  ],
  priceDollars: 6.66,
  description:
    "Material: \n * Titanium Steel \n\n Weight: \n * 4g \n\n Feature: \n * Iconic Protective Eye Motif \n * Hand-Poured Enamel Flames \n * Self-Adjusting Open Band \n * Euro Gothic Design \n * Fadeproof Coating \n\n Note: \n * Size adjusts 14-19mm \n * Care: Dry cloth only \n * Avoid water exposure",
  tags: [],
  msrpDollars: 13.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:03.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
